<template>
    <v-content class="login">
        <!-- logo -->
        <v-row align-content="center" justify="center" no-gutters class="logo">
            <img :src="top_logo_image" height="50px" style="width:auto; max-width:100%;" />
        </v-row>

        <div class="px-3 mt-10">
            <div class=" text-center">
                <h1 class="subtitle-1 font-weight-black mb-10" style="border-bottom: solid 1px #000; display: inline-block;">パスワード再設定</h1>
            </div>
            <p class="body-2 mb-5">新しいパスワードを入力してください。</p>
            <ValidationObserver ref="observer">
            <v-row class="mb-10">
                <v-col cols="12" sm="6" class="pb-0">
                  <ValidationProvider v-slot="{ errors }" name="パスワード" rules="required|alpha_num|max:128|min:8">
                    <p class="subtitle-2 font-weight-black ma-0">パスワード</p>
                    <v-text-field v-model="password" single-line outlined dense :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'" @click:append="show1 = !show1" :error-messages="errors" required></v-text-field>
                  </ValidationProvider>
                </v-col>
            </v-row>

            <div class="text-center">
                <v-btn rounded class="maincolor-bg default_button mb-5" @click.stop="sendPassword">パスワード再設定</v-btn>
            </div>
            </ValidationObserver>

            <div class="text-center caption pt-10">
                <p class="caption" v-if="inquiryMail">
                    <v-icon>far fa-envelope</v-icon> <a :href="'mailto:'+inquiryMail">お問い合わせ</a>
                </p>
            </div>

            <p class="text-center" v-if="copyright" style="font-size: 12px; margin-top:60px;">© {{copyright}} All right reserved.</p>
        </div>

        <v-overlay :value="loading">
          <v-progress-circular :size="80" :width="2" class="maincolor" indeterminate></v-progress-circular>
        </v-overlay>

        <v-dialog v-model="dialog" persistent>
            <v-card class="ticket_dialogue text-center pa-5">
                <h3 class="subtitle-1 font-weight-bold mb-10">パスワードを再設定いたしました</h3>
                <p class="body-2 mb-10">アプリを起動してログイン画面より、再設定いただいたパスワードを入力して、ログインください。</p>
            </v-card>
        </v-dialog>

    </v-content>
</template>

<script>
import { required, alpha_num, max, min } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
setInteractionMode('eager')
extend('required', {
  ...required,
  message: '{_field_} は必須項目です。',
})

extend('alpha_num', {
  ...alpha_num,
  message: '英数字のみが利用できます',
})

extend('max', {
  ...max,
  message: '128文字以内で入力してください。',
})

extend('min', {
  ...min,
  message: '8文字以上で入力してください。',
})

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data: () => ({
    show1: false,
    init: [],
    loading: false,
    dialog: false,
    password: '',
    result: '',
    resultapi: [],
    passTokenRes: [],
    shopini: [],
    maincolor: '',
    copyright: '',
    top_logo_image: '',
    shopName: '',
    inquiryMail: ''
  }),
  async created() {
    this.init = this.storageGet('*')
    console.log(this.init)
    //パスワードリセットトークン有効チェック
    try {
      var passTokenReq = {
        sid: this.init.sid,
        service_cd: this.init.service_cd,
        password_reset_token : this.init.password_reset_token,
      }
      console.log(passTokenReq)

      var passTokenRes = await this.apiCall('/password-reset-token', passTokenReq, 'post', 2)
      this.$set(this, 'passTokenRes', passTokenRes)
      if(this.passTokenRes.status != 200){
        this.callDialog('エラー', this.passTokenRes.message, 0);
      }

      //ページ表示に必要な情報を取得
      var shopReq = { params: {
        sid: this.init.sid
      }}
      var shopRes = await this.apiCall('/user/shop', shopReq)
      if (!shopRes) {
        this.storageSave(JSON.stringify(shopRes))
      }
      this.top_logo_image = shopRes.top_logo_image
      this.copyright = shopRes.copyright
      this.shopName = shopRes.shop_name
      this.inquiryMail = shopRes.inquiry_mail

      //メインカラーを設定する
      this.$set(this, 'maincolor', shopRes.main_color);
      const $ = el => document.querySelector(el);
      $(':root').style.setProperty('--main_color', shopRes.main_color);
      //console.log(this.init)

    } catch(e) {
      this.loading = false
      this.callDialog('エラー', this.passTokenRes.message, 3);
    }
  },
  methods : {
    sendPassword: function(){
      this.$refs.observer.validate().then(async result => {
        if (result) {
          try {
            //loadingを表示
            this.loading = true
            // パスワードリセット申請API実行
            var req = {
              sid: this.init.sid,
              service_cd: this.init.service_cd,
              password: this.password,
              password_reset_token : this.init.password_reset_token,
            }
            var res = await this.apiCall('/password-reset', req, 'post', 2);
            this.$set(this, 'resultapi', res)
            if (!res) {
              this.loading = false
              return false
            }

            if(this.resultapi.status == 200){
              this.loading = false
              this.dialog = true
            }else{
              throw "error"
            }

          } catch(e) {
            this.loading = false
            this.callDialog('エラー', this.resultapi.message, 1);
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.fontsize12>>>label {
    font-size: 12px;
}

a {
    color: #333333;
}
</style>
